import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const BIRelationshipScopeContext = /*#__PURE__*/createContext(null);
export const BIRelationshipScopeProvider = _ref => {
  let {
    relationshipScope,
    children
  } = _ref;
  return /*#__PURE__*/_jsx(BIRelationshipScopeContext.Provider, {
    value: relationshipScope,
    children: children
  });
};
export const useBIRelationshipScope = () => {
  return useContext(BIRelationshipScopeContext);
};